module.exports = __webpack_public_path__ + "img/keyboard-arrow-back.e388ca95.svg";